import React, { useContext, useEffect, useRef } from 'react';

import { FormattedMessage } from '@techstyle/react-intl';

import { useLDFlags } from '../../utils/LD/useLDFlags';
import { useIsShoppingBagRevampUX } from '../MemberCreditsCartToggle/MemberCreditsCartToggle';
import ToastContext from '../ToastContext/ToastContext';

// We need to delay triggering the toast message bc the add/remove item toast messages conflict
const TOAST_DELAY = 2000;

export function useMemberCreditsToastMessage({ creditsRemaining }) {
  const { 'token-to-cash-v2': tokenToCashv2Enabled } = useLDFlags();
  const { showMessage: showToastMessage } = useContext(ToastContext.Context);
  const isShoppingBagRevampUX = useIsShoppingBagRevampUX();
  const lastTime = useRef(creditsRemaining);

  useEffect(() => {
    if (isShoppingBagRevampUX) {
      return;
    }
    const diff = creditsRemaining - (window.last_credit ?? lastTime.current);

    if (tokenToCashv2Enabled) {
      if (diff === 1) {
        setTimeout(
          () =>
            showToastMessage(
              <FormattedMessage
                id="global_checkout.remove_member_credit_toast"
                defaultMessage="Your Member Credit was successfully removed!"
              />
            ),
          TOAST_DELAY
        );
      } else if (diff > 1) {
        setTimeout(
          () =>
            showToastMessage(
              <FormattedMessage
                id="global_checkout.remove_member_credits_toast"
                defaultMessage="Your Member Credits were successfully removed!"
              />
            ),
          TOAST_DELAY
        );
      } else if (diff === -1) {
        setTimeout(
          () =>
            showToastMessage(
              <FormattedMessage
                id="global_checkout.apply_member_credit_toast"
                defaultMessage="Your Member Credit was successfully applied!"
              />
            ),
          TOAST_DELAY
        );
      } else if (diff < -1) {
        setTimeout(
          () =>
            showToastMessage(
              <FormattedMessage
                id="global_checkout.apply_member_credits_toast"
                defaultMessage="Your Member Credits were successfully applied!"
              />
            ),
          TOAST_DELAY
        );
      }
    }
    lastTime.current = creditsRemaining;
    window.last_credit = null;
  }, [
    creditsRemaining,
    showToastMessage,
    tokenToCashv2Enabled,
    isShoppingBagRevampUX,
  ]);

  useEffect(() => {
    return () => {
      if (isShoppingBagRevampUX) {
        return;
      }
      /**
       * This is needed bc this component unmounts when we remove an item, I need to persist this
       * through the unmount and remount
       */
      window.last_credit = creditsRemaining;
    };
  }, [isShoppingBagRevampUX, creditsRemaining]);
}
